import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { events } from '../../mocks/events';

const EventsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-gradient-to-br from-[#0F1419] via-[#1A2332] to-[#0F1419]"
          style={{
            backgroundImage: `radial-gradient(circle at 30% 40%, rgba(0, 120, 212, 0.12) 0%, transparent 50%),
                             radial-gradient(circle at 70% 70%, rgba(16, 185, 129, 0.08) 0%, transparent 50%),
                             repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.02) 2px, rgba(255,255,255,0.02) 4px)`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
        <div className="relative max-w-5xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl font-bold text-white mb-6 drop-shadow-lg">Etkinlikler</h1>
            <p className="text-xl text-white/95 leading-relaxed max-w-3xl mx-auto drop-shadow-md">
              Siber güvenlik konularında verdiğim sunumlar, katıldığım konferanslar ve topluluk
              etkinlikleri.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Events Timeline */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-8">
          <div className="space-y-16">
            {events.map((event, index) => (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div
                  className={`flex items-stretch gap-0 ${
                    index % 2 === 1 ? 'flex-row-reverse' : ''
                  }`}
                >
                  {/* Görsel Tarafı */}
                  <div className="w-1/2 relative group overflow-hidden rounded-2xl">
                    <div className="relative w-full h-[420px] overflow-hidden rounded-2xl">
                      <img
                        src={event.imageUrl}
                        alt={event.title}
                        title={`${event.title} - ${event.name}`}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                      {/* Tarih Rozeti */}
                      <div className="absolute top-5 left-5 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-3 shadow-lg">
                        <div className="text-2xl font-bold text-gray-900 leading-none text-center">
                          {new Date(event.date).getDate()}
                        </div>
                        <div className="text-xs font-semibold text-gray-500 uppercase mt-1 text-center">
                          {new Date(event.date).toLocaleDateString('tr-TR', {
                            month: 'short',
                          })}
                        </div>
                        <div className="text-xs text-gray-400 text-center">
                          {new Date(event.date).getFullYear()}
                        </div>
                      </div>

                      {/* Tür Rozeti */}
                      <div className="absolute top-5 right-5 bg-emerald-500 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
                        {event.topics[0]}
                      </div>
                    </div>
                  </div>

                  {/* İçerik Tarafı */}
                  <div
                    className={`w-1/2 flex flex-col justify-center ${
                      index % 2 === 1 ? 'pr-12' : 'pl-12'
                    }`}
                  >
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">
                      {event.title}
                    </h3>

                    {/* Konum */}
                    <div className="flex items-center gap-4 mb-5">
                      <span className="flex items-center gap-1.5 text-sm text-gray-500">
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-map-pin-2-fill text-red-400"></i>
                        </span>
                        {event.location}
                      </span>
                    </div>

                    <p className="text-base text-gray-600 leading-relaxed mb-6 line-clamp-4">
                      {event.description}
                    </p>

                    {/* Konular */}
                    <div className="flex flex-wrap gap-2 mb-8">
                      {event.topics.slice(0, 4).map((topic) => (
                        <span
                          key={topic}
                          className="px-3 py-1.5 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200"
                        >
                          {topic}
                        </span>
                      ))}
                      {event.topics.length > 4 && (
                        <span className="px-3 py-1.5 bg-gray-50 text-gray-400 text-xs font-medium rounded-full">
                          +{event.topics.length - 4}
                        </span>
                      )}
                    </div>

                    {/* Aksiyon */}
                    <div>
                      <a
                        href={event.linkedInUrl}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white text-sm font-medium rounded-xl transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-gray-900/20 hover:shadow-gray-900/30"
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-linkedin-box-fill text-base"></i>
                        </span>
                        LinkedIn&apos;de Gör
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-arrow-right-up-line text-sm"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-2xl mx-auto mb-6">
              <i className="ri-mic-line text-2xl text-white"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Etkinliğinize Konuşmacı Olarak Davet Edin
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Microsoft güvenlik çözümleri hakkında sunumlar&nbsp; ve teknik oturumlar
              için iletişime geçebilirsiniz.
            </p>
            <a
              href="mailto:security.mvp@example.com"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-xl transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-gray-900/20"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-send-line text-base"></i>
              </span>
              İletişime Geç
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;
